import { customerSearchColumns, groupColumns, regionColumns } from '@/constants/search-columns';
import { Group, GroupType, KhachHang, KhuVuc } from '@/types/schemas';
import { FormField, SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { QUERY_KEYS } from '@/constants';

interface DetailsTabProps {
  searchFieldStates: {
    customer: KhachHang | null;
    setCustomer: (customer: KhachHang | null) => void;
    customerGroup1: Group | null;
    setCustomerGroup1: (group: Group | null) => void;
    customerGroup2: Group | null;
    setCustomerGroup2: (group: Group | null) => void;
    customerGroup3: Group | null;
    setCustomerGroup3: (group: Group | null) => void;
    region: KhuVuc | null;
    setRegion: (region: KhuVuc | null) => void;
  };
}

const DetailsTab: React.FC<DetailsTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='min-w-[900px] space-y-2 p-4'>
      <div className='flex flex-col space-y-1'>
        {/* 1. Mã khách hàng */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã khách hàng:</Label>
          <SearchField<KhachHang>
            type='text'
            columnDisplay={'customer_code'}
            displayRelatedField={'customer_name'}
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
            searchColumns={customerSearchColumns}
            value={searchFieldStates.customer?.customer_code || ''}
            relatedFieldValue={searchFieldStates.customer?.customer_name || ''}
            onRowSelection={searchFieldStates.setCustomer}
          />
        </div>

        {/* 2. Nhóm khách hàng */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Nhóm khách hàng:</Label>
          <div className='flex'>
            <SearchField<Group>
              columnDisplay={'ma_nhom'}
              searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=${GroupType.CUSTOMER1}`}
              searchColumns={groupColumns}
              value={searchFieldStates.customerGroup1?.ma_nhom || ''}
              relatedFieldValue={searchFieldStates.customerGroup1?.ten2 || ''}
              onRowSelection={searchFieldStates.setCustomerGroup1}
              className='w-48'
            />
            <SearchField<Group>
              type='text'
              columnDisplay={'ma_nhom'}
              searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=${GroupType.CUSTOMER2}`}
              searchColumns={groupColumns}
              value={searchFieldStates.customerGroup2?.ma_nhom || ''}
              relatedFieldValue={searchFieldStates.customerGroup2?.ten2 || ''}
              onRowSelection={searchFieldStates.setCustomerGroup2}
              className='w-48 pl-2'
            />
            <SearchField<Group>
              type='text'
              columnDisplay={'ma_nhom'}
              searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=${GroupType.CUSTOMER3}`}
              searchColumns={groupColumns}
              value={searchFieldStates.customerGroup3?.ma_nhom || ''}
              relatedFieldValue={searchFieldStates.customerGroup3?.ten2 || ''}
              onRowSelection={searchFieldStates.setCustomerGroup3}
              className='w-48 pl-2'
            />
          </div>
        </div>

        {/* 3. Khu vực */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Khu vực:</Label>
          <SearchField<KhuVuc>
            type='text'
            columnDisplay={'rg_code'}
            displayRelatedField={'rgname'}
            searchEndpoint={`/${QUERY_KEYS.KHU_VUC}`}
            searchColumns={regionColumns}
            value={searchFieldStates.region?.rg_code || ''}
            relatedFieldValue={searchFieldStates.region?.rgname || ''}
            onRowSelection={searchFieldStates.setRegion}
          />
        </div>

        {/* Nhóm theo */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Nhóm theo:</Label>
          <div className='w-[500px]'>
            <FormField
              name='group_by'
              type='select'
              options={[
                { value: '1', label: 'Nhóm khách 1' },
                { value: '2', label: 'Nhóm khách 2' },
                { value: '3', label: 'Nhóm khách 3' }
              ]}
            />
          </div>
        </div>
        {/* 9. Mẫu báo cáo */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mẫu báo cáo:</Label>
          <FormField
            name='mau_bc'
            type='select'
            options={[
              { value: 20, label: 'Mẫu tiền chuẩn' },
              {
                value: 30,
                label: 'Mẫu ngoại tệ'
              }
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
